export default "__VITE_ASSET__DD6$5y5J__"